const modalPropsReducer = ( state, action ) =>
{
    switch ( action.type )
    {
        case 'setProps':
            return action.props;
        default:
            return state;
    }
};
export default function useModalProps ( modalId, componentProps, initial, options = {} )
{
    const [ props, dispatch ] = React.useReducer ( modalPropsReducer, initial, () => ( { ...componentProps } ) );

    React.useEffect ( () =>
    {
        const registerProps = function ( e, instance )
        {
            if ( instance.current.src === '#' + modalId )
            {
                const extraProps = options.getPropsFromInstance ? options.getPropsFromInstance ( instance ) : {};
                dispatch ( { type: 'setProps', props: { ...componentProps, ...initial, ...extraProps, ...( instance.current.props || {} ) } } );
            }
        };

        const unregisterProps = function ( e, instance )
        {
            if ( instance.current.src === '#' + modalId )
            {
                dispatch ( { type: 'setProps', props: initial } );
            }
        };

        $ ( document ).on ( 'afterShow.fb', registerProps );
        $ ( document ).on ( 'afterClose.fb', unregisterProps );

        return () =>
        {
            $ ( document ).off ( 'afterShow.fb', registerProps );
            $ ( document ).off ( 'afterClose.fb', unregisterProps );
        };
    }, [ modalId, componentProps, initial, options ] );

    return props;
};